export default __webpack_public_path__ + "static/media/pay_later.773a2dcd.png";